/**
 * Payments → "Download Invoice": the invoice endpoint carries a per-request token, so
 * it must not be rendered as an <a href> (that leaks the URL + token into the browser
 * status bar on hover). The link holds the URL in data-invoice-url instead; open it via
 * JS on click / Enter / Space. Delegated on the page root so it survives sub-tab toggles.
 */
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.myaccount');
    if (!root) return;

    function openInvoice(el) {
        var url = el.getAttribute('data-invoice-url');
        if (!url || url === '#') return;
        // Trigger the download in place — no new tab / blank page. The invoice endpoint
        // responds with Content-Disposition: attachment, so a same-tab anchor click
        // downloads the file without navigating the page away.
        var a = document.createElement('a');
        a.href = url;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    root.addEventListener('click', function (e) {
        var el = e.target.closest('[data-invoice-url]');
        if (!el) return;
        e.preventDefault();
        openInvoice(el);
    });

    root.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        var el = e.target.closest('[data-invoice-url]');
        if (!el) return;
        e.preventDefault();
        openInvoice(el);
    });
});
